import { useAppDispatch, useAppSelector } from 'hooks/typedReduxHooks';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { fetchRulesByParams } from 'store/slices/rulesSlice';
import prepareSearchParams from 'utils/prepareSearchParams';

interface IProps {
  paramName: string;
  paramValue: string;
  text: [string, string];
}

const ParamButton = ({ paramName, paramValue, text }: IProps) => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { searchParams: savedSearchParams } = useAppSelector(((state) => state.rules));
  const preparedSearchParams = prepareSearchParams(savedSearchParams);

  const buttonText = searchParams.get(paramName) ? text[1] : text[0];

  const onClickParamButton = () => {
    const isExistParam = !!searchParams.get(paramName);

    if (isExistParam) {
      searchParams.delete(paramName);
    } else {
      searchParams.set(paramName, paramValue);
    }

    setSearchParams(searchParams);

    dispatch(fetchRulesByParams({
      ...preparedSearchParams,
      ...searchParams,
      [paramName]: paramValue,
      page: 1,
    }));
  };

  return (
    <button
      className="bg-white rounded-sm shadow-md text-gray-69 text-sm px-[14px]"
      type="button"
      onClick={onClickParamButton}
    >
      {buttonText}
    </button>
  );
};

export default ParamButton;
